module.exports = __webpack_public_path__ + "img/liushui (4).06982f5b.png";